<template>
  <Modal 
    :id="'cmp_bookings_booking_add_artist'"
    @cancelled="onCancelClick"  
  >
    <template slot="header">
      {{title}}
    </template>
    <template slot="body">
     
      <div class="ut-fh ut-fc" style="max-height:300px;height:300px">
        <NTable
          id="catalog-releases-releases_list"
          class="h1"
          :config="tableConfig"
          :headers="Headers"
          :items="list"
          thpad="0px"
          tdpad="0px"
          thspad="0px 10px 0px 10px"
          tdbdr="1px solid var(--sprt-12)"
        >
          <template v-slot:item="{ item, tdcon }">
            <tr>
              <td v-bind="tdcon('account_name')">
                <span>{{item['account_name']}} </span>
               
              </td>
              <td v-bind="tdcon('order_qty')">
                <span>{{item['order_qty']}}</span>
              </td>
              <td v-bind="tdcon('shipped_qty')">
                <span>{{item['shipped_qty'] }}</span>
              </td>
              <td v-bind="tdcon('open')">
                <span >{{item['open_qty']}}</span>
              </td>
              <td v-bind="tdcon('pr')">
                <div class="ut-rowcen">
                  <div class="dt-checkbox v2 s1 ">
                    <input
                      class="disabled"
                      type="checkbox"
                      :name="'promo'"
                      :id="'promo'"
                      :checked="item['promo']==1"
                      @click="e => onCheckBoxChange(e, item)"
                    />
                    <div class="checkmark"></div>
                  </div>
                </div>
              </td>
              <td v-bind="tdcon('ship_now')">
                <TextField2
                  type="text"
                  class="dbox1"
                  id="shipped_now"
                  :showLabel="false"
                  :disabled="false"
                  :value="item['shipped_now']||''"
                  :bb="'0px'"
                  @change="e => onTextFieldChange(e, item)"
                />  
              </td>
              <td v-bind="tdcon('costs_reference_no')">
                <TextField2
                  type="text"
                  class="dbox1"
                  id="reference_no"
                  :showLabel="false"
                  :disabled="false"
                  :value="item['reference_no']||''"
                  :bb="'0px'"
                  @change="e => onTextFieldChange(e, item)"
                />  
              </td>
              <td v-bind="tdcon('invoice')">
                <div class="ut-rowcen">
                  <div class="dt-checkbox v2 s1 ">
                    <input
                      class="disabled"
                      type="checkbox"
                      :name="'invoice'"
                      :id="'invoice'"
                      :checked="item['invoice']==1"
                      @click="e => onCheckBoxChange(e, item)"
                    />
                    <div class="checkmark"></div>
                  </div>
                </div>
              </td>
              <td v-bind="tdcon('ppu')">
                <TextField2
                  type="text"
                  class="dbox1"
                  id="ppu"
                  :showLabel="false"
                  :disabled="false"
                  :value="item['invoice']==1?item['ppu']:''"
                  :bb="'0px'"
                  @change="e => onTextFieldChange(e, item)"
                />  
              </td>        
            </tr>
          </template>
            </NTable>
         

       
            </div>
        
    </template>
    <template slot="options">
   
      <template>
        
        <button class="dt-button s7" @click="onCancelClick" >Cancel</button>
        <button 
          class="dt-button s7 v1"
          :class="{ disabled: !isTableValid }"
          :disabled="!isTableValid" 
          @click="onOKClicked" 
        >{{$dft.capHead($t('proceed'))}}
        </button>
        
      </template>
    
    </template>
  </Modal>
</template>

<script>
import Modal from '../../../../dt-plugins/modal/modal';


import NTable from "../../../../plugins/datatable/datatable";








import ModalContainer from "@dtplugins/modal/modal-container";

import {  closeModalRoute  } from "../../../../dt-plugins/modal/modal.mixin";


import { createNTableConfig } from '../../../../plugins/datatable';

import { createTableHeader } from "../../../../plugins/datatable";



import {
  createTV,
  tv,
} from "../../../../models/text-value.model";


import { MHTTPCL } from '../../../../services/http/http-client';
import { SupplierOrdersService } from '../../services/supplier.order.service';

import { Subject } from "rxjs";
import { waitForAnimation, subscribeSubject } from "@/utility";
import values from 'lodash/values';

export default {
  components: {
    
    Modal,
    NTable,


    ModalContainer,   
    //AdvanceSearch,
   
  },
  mounted:async  function () {
    const modalInitData = await SupplierOrdersService.accountDelivery({ supplier_order_id:this.supplier_order_id , shipping_date:this.shipping_date});
    console.log("::::::::::::::::",modalInitData);

    this.so = modalInitData.data.so

    this.list = modalInitData.data.orderlines
  
  },
  data: function () {
    return {

      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
        immediateValidation: false,
      },
      
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true
      }),

      list:[],

      so:{},

    
      

      product_type_id:'',


    };
  },
  mixins: [
    
  ],

  computed: {
    Headers: function () {
      return [
        createTableHeader("account_name", { }),
        createTableHeader("order_qty", { mw:70 }),
        createTableHeader("shipped_qty", { }),
        createTableHeader("open", { mw:60}),
        createTableHeader("pr", { text:'PR',mw:40 ,ta:'center'}),
        createTableHeader("ship_now", { }),
        createTableHeader("costs_reference_no", { }),
        createTableHeader("invoice", { ta:'center',mw:70 }),
        createTableHeader("ppu", { })
        
        
        
      ]      
    },
    supplier_order_id:function(){
      return this.$route.query.supplier_order_id;
    },


    shipping_date:function(){
      return this.$route.query.shipping_date;
    },

    title:function(){
      return `${this.supplier_order_id} ${this.so?.supply_order_type_name} - ${this.so?.catalog_no}`
    },

    isTableValid:function(){
      return this.list.reduce((accum,cur)=>{
        if(cur.shipped_now && parseInt(cur.shipped_now)){
          accum = true
        }

        return accum;
        
      },false)
    }
  
  
    
  },
  methods: { 
  
    onOKClicked:async function(){
      const arrayPayload = this.list.filter(e=>e.shipped_now!=undefined).map(x=>{
        return{
          supplier_orderline_id:x.supplier_orderline_id,
          promo:x.promo,
          shipped_now:x.shipped_now,
          invoice:x.invoice,
          currency_id:x.currency_id,
          exchange_rate:x.exchange_rate,
          account_id:x.account_id,
          invoice_project_id:x.invoice_project_id,
          contact_id_invoice:x.contact_id_invoice,
          price_list_id:x.price_list_id
        }
      });

      const sumShipped = arrayPayload.reduce((accum,cur)=>{
        console.log('accum,cur' ,{accum,cur ,arrayPayload})
        return accum+=cur['shipped_now'];
      },0)

      const finalPayload = {
        supplier_order_id:this.supplier_order_id,
        supplier_orderlines:arrayPayload,
        sum_shipped:sumShipped,
        shipping_date:this.shipping_date

      };

      this.$emit('update',finalPayload);

      // console.log(arrayPayload,"{{{{{}}}}}");
    },
    onDoneClick:function(){
      this.$emit("onAdd",this.supplier_order_id)
    },

    onCancelClick: function() {
      this.$emit("cancelled", true);
    },
    onTextFieldChange: function(e, item) {
      const { account_id } = item;
      console.log("pif", e.value, parseInt(e.value), parseFloat(e.value));
      this.list = this.list.map(x => {
        

        if(x.account_id == account_id){
          if(e.name == 'shipped_now'){
            if(parseInt(e.value)){
              return {
                ...x,
                shipped_now: parseInt(e.value)
              }
            }else{
              delete x.shipped_now
              return x;
            }
            
          } else if(e.name == 'ppu'){

            if(x['invoice'] && parseFloat(e.value)){
              return {
                ...x,
                ppu: parseFloat(e.value)
              }
            }else{
              return x;
            }
          } else {
            return {
              ...x,
              [e.name]:e.value
            }
          }
        } else{
          return x;
        }
      });
    },
    onCheckBoxChange: function(e, item) {
        console.log("::::::::::",e.target.checked,e.target.id,item)

        const value = e.target.checked ? 1:0

      const { account_id } = item;
      this.list = this.list.map(x => {
     

        if(x.account_id == account_id){
          return{
            ...x,
            [e.target.id]:value
          }
        } else{
          return x;
        }
      });
    }



  
  },

};


      // { 
      //   supplier_order_id:185,
      //   supplier_orderlines:[
      //       {
      //         supplier_orderline_id:390,
      //         promo:1,
      //         shipped_now:100,
      //         reference_no:'100-D',
      //         invoice:1,ppu:20,
      //         currency_id:1,
      //         exchange_rate:1,
      //         account_id:279,
      //         invoice_project_id:206,
      //         contact_id_invoice:'',
      //         price_list_id:''
      //       }
      //     ],
      //     sum_shipped:100,
      //     shipping_date:'2022-07-25'
      //   }

      // {
      //   supplier_order_id:185,
      //   supplier_orderlines:[
      //     {
      //       supplier_orderline_id:391,
      //       promo:1,
      //       shipped_now:11,
      //       reference_no:110,
      //       invoice:1,
      //       ppu:5,
      //       currency_id:1,
      //       exchange_rate:1,
      //       account_id:180,
      //       invoice_project_id:1,
      //       contact_id_invoice:'',
      //       price_list_id:3
      //     },
      //     {
      //       supplier_orderline_id:392,
      //       promo:1,
      //       shipped_now:12,
      //       reference_no:120,
      //       invoice:1,
      //       ppu:4.65,
      //       currency_id:1,
      //       exchange_rate:1,
      //       account_id:272,
      //       invoice_project_id:1,
      //       contact_id_invoice:'',
      //       price_list_id:2
      //     }
      //   ],
      //   sum_shipped:23,
      //   shipping_date:2022-07-25
      //   }
</script>